export default "__VITE_ASSET__CsbMFnWF__ 480w, __VITE_ASSET__C3_p3aO8__ 768w, __VITE_ASSET__C2YLefT4__ 960w";